import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

// app
import { quoteBindAxios } from 'lib/quoteBind';
import { enqueueNotification } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
export const useUpdateIssue = () => {
  const dispatch = useDispatch();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.mutations.useUpdateIssue',
    };

    dispatch(enqueueNotification('notification.updateIssue.fail', 'error'));

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = (res) => {
    dispatch(enqueueNotification('notification.updateIssue.success', 'success'));
  };

  return useMutation(
    async ({ id, status, quoteId }) => {
      if (!status || !id || !quoteId) {
        throw new Error('Invalid data');
      }

      const result = await quoteBindAxios.put(`issues/${id}/${status}`);
      return result?.data;
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
